import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Container from '../Container';

const defaultProps = {
  isStatic: false,
  onClose: () => {},
};

const propTypes = {
  isStatic: PropTypes.bool,
  onClose: PropTypes.func,
};

const ModalBackdrop = ({
  isStatic,
  onClose,
}) => (
  <Container
    className={classnames(
      'fixed z-20 w-screen h-screen top-0 left-0 right-0 bottom-0 bg-black opacity-75',
      'overflow-x-hidden overflow-y-scroll',
      !isStatic && 'cursor-pointer',
      isStatic && 'pointer-events-none',
    )}
    onClick={() => isStatic && onClose()}
  />
);

ModalBackdrop.defaultProps = defaultProps;
ModalBackdrop.propTypes = propTypes;

export default ModalBackdrop;
